import { render, staticRenderFns } from "./AlertExpiredPlan.vue?vue&type=template&id=295340e8"
import script from "./AlertExpiredPlan.vue?vue&type=script&lang=js"
export * from "./AlertExpiredPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports